module.exports = __webpack_public_path__ + "img/P41-en.a2e0dbe4.png";